import { IExternalTooltipContent } from "../../../../../../../../components/common/chart-plugins";

interface IAppendMarkerBandTooltipContentOptions {
  content: IExternalTooltipContent;
  markerValue: number | null | undefined;
  cursorValue: number | null | undefined;
  label: string;
  units?: string;
  formatValue: (value: number) => string;
}

interface IAppendMarkerPowerTooltipContentOptions {
  content: IExternalTooltipContent;
  power: number | null;
  label: string;
  units?: string;
  formatValue: (value: number) => string;
}

interface ILabeledMarkerValue {
  label: string;
  value: string;
  units?: string;
}

interface IBuildMarkerTooltipContentOptions {
  title?: string;
  x: ILabeledMarkerValue;
  amplitude: ILabeledMarkerValue;
}

const formatLabeledValue = ({ label, value, units }: ILabeledMarkerValue): string =>
  `${label}: ${value}${units ? ` ${units}` : ""}`;

export const buildMarkerTooltipContent = ({
  title,
  x,
  amplitude,
}: IBuildMarkerTooltipContentOptions): IExternalTooltipContent => ({
  titleLines: title ? [title] : [],
  bodyLines: [formatLabeledValue(x), formatLabeledValue(amplitude)],
});

export const appendMarkerBandTooltipContent = ({
  content,
  markerValue,
  cursorValue,
  label,
  units,
  formatValue,
}: IAppendMarkerBandTooltipContentOptions): IExternalTooltipContent => {
  if (
    typeof markerValue !== "number" ||
    !Number.isFinite(markerValue) ||
    typeof cursorValue !== "number" ||
    !Number.isFinite(cursorValue)
  ) {
    return content;
  }

  const band = formatValue(Math.abs(cursorValue - markerValue));
  const suffix = units ? ` ${units}` : "";

  return {
    ...content,
    bodyLines: [...(content.bodyLines ?? []), `${label}: ${band}${suffix}`],
  };
};

export const appendMarkerPowerTooltipContent = ({
  content,
  power,
  label,
  units,
  formatValue,
}: IAppendMarkerPowerTooltipContentOptions): IExternalTooltipContent => {
  if (power === null || !Number.isFinite(power)) {
    return content;
  }

  const suffix = units ? ` ${units}` : "";
  return {
    ...content,
    bodyLines: [...(content.bodyLines ?? []), `${label}: ${formatValue(power)}${suffix}`],
  };
};
